import React from 'react';
import { Grid, Label, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import { Route } from 'react-router';
import moment from 'moment';
import classnames from 'classnames';

import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import SessionMenu from 'PointOfSale/modules/layouts/container/servingOptions/SessionMenu';
import { POS_ROUTES } from 'PointOfSale/modules/common/constants';
import 'PointOfSale/styles/components/pageHeader.less';

const PageHeader = props => {
  const {
    siteDate,
    selectedSiteDetails,
    showSiteSetupPopup,
    changeFontSize,
    online,
    toggleFullscreen,
    fullscreen,
    onHomeClick,
    hasMealCounterSession,
    showServingStatus,
    profile,
  } = props;

  const isCep =
    _.get(selectedSiteDetails, 'AlternateProvisionTypeId') ===
    AlternateProvisionTypeEnum.CEP;
  const siteName = `${_.get(selectedSiteDetails, 'Id')} ${_.get(
    selectedSiteDetails,
    'Description'
  )}`;
  const hasSiteDate = moment(siteDate).isValid();
  /**
   * Show date / name after the user has selected both, otherwise hide
   */
  const showDetails = siteName && hasSiteDate;

  const statusToClassMap = {
    '2': 'bg-orange',
    '3': 'bg-green',
  };

  return (
    <React.Fragment>
      <Grid.Column
        floated="left"
        width={3}
        className="site-details"
        onClick={showSiteSetupPopup}
      >
        <Grid.Row>
          <Grid.Column width={3} className="date-cep-flag">
            {showDetails && (
              <React.Fragment>
                <div>{siteDate.format(DATE_FORMAT_FOR_UI)}</div>
                {isCep && (
                  <Label horizontal>CEP {hasMealCounterSession && 'ON'}</Label>
                )}
              </React.Fragment>
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} className="site-name">
            {showDetails && siteName}
          </Grid.Column>
        </Grid.Row>
      </Grid.Column>
      <Grid.Column width={7}>
        <Route path={POS_ROUTES.SERVING} component={SessionMenu} />
      </Grid.Column>
      <Grid.Column floated="right" width={6} verticalAlign="middle">
        <Grid.Row floated="right">
          <Grid.Column width={3} className="site-name">
            <Grid.Row className="header-icon-container">
              <div className="header-icon no-pointer">
                <Label
                  className={classnames(
                    'meal-count-label',
                    showServingStatus && statusToClassMap[profile.StatusCurrent]
                  )}
                  circular
                >
                  {_.get(selectedSiteDetails, 'mealCount', '-')}
                </Label>
                <div className={'icon-label'}>Meal Count</div>
              </div>
              <div className="header-icon no-pointer">
                <Icon
                  name={'circle'}
                  size="large"
                  color={online ? 'green' : 'red'}
                />
                <div className={'icon-label'}>
                  {online ? 'Online' : 'Offline'}
                </div>
              </div>
              <div className="header-icon" onClick={changeFontSize}>
                <div className="font-resizer">
                  <Icon name="font" size="large" />
                  <div className={'icon-label'}>Font Size</div>
                </div>
              </div>
              <div className="header-icon" onClick={toggleFullscreen}>
                <Icon name={fullscreen ? 'compress' : 'expand'} size="large" />
                <div className={'icon-label'}>Full Screen</div>
              </div>
              <div className="header-icon" onClick={onHomeClick}>
                <Icon name="sign out" flipped="horizontally" size="large" />
                <div className={'icon-label'}>Back</div>
              </div>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid.Column>
    </React.Fragment>
  );
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/PageHeader.js